import $ from 'jquery';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    events: {
        'click .box-url-share'   : 'onCopy',
        'click #start_at_toggle' : 'onStartAtToggle'
    },

    dom_handlers: {
        onCopy: function(e) {
            Util.copyText($(e.currentTarget).text(), () => {
                this.$el.find('.copy-success').css('opacity', 1);

                setTimeout(() => {
                    this.$el.find('.copy-success').css('opacity', 0);
                }, 4000);
            });
        },

        onStartAtToggle: function(e) {
            var share_url;

            if ($(e.currentTarget).is(':checked') && this.start_at) {
                share_url = this.model.getShareUrl() + '?t=' + this.start_at;
            } else {
                share_url = this.model.getShareUrl();
            }

            this.$el.find('.preview').attr('href', share_url);
            this.$el.find('.box-url-share').text(share_url);
        }
    },

    initialize: function(options) {
        this.start_at = options.start_at;
    },

    render: function() {
        var share_url = this.model.getShareUrl();

        if (this.start_at) {
            share_url += '?t=' + this.start_at.replace('00:', '0:');
        }

        var content =
        '<p>Copy this private link to share: (<a class="preview" href="' + share_url + '" target="_blank" rel="noopener">open in a new window</a>)</p>' +
        '<div class="box-url-share">' + share_url + '</div>' +
        '<div class="flex-between margin-top-12">' +
            '<div>' +
                (typeof this.start_at === 'undefined' ? '' :
                '<input type="checkbox" id="start_at_toggle" checked><label for="start_at_toggle">Start at ' + (this.start_at || '00:00').replace('00:', '0:') + '</label>') +
            '</div>' +
            '<div class="copy-success text-success text-align-right margin-top-8 font-weight-medium" style="opacity:0;">Link copied <i class="fas fa-check-circle"></i></div>';
        '</div>' +

        this.$el.html(content);

        return this;
    }
});